export default function deleteSslCertificateReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GET_SSL_CERTIFICATES_DELETE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_SSL_CERTIFICATES_DELETE_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_SSL_CERTIFICATES_DELETE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}